import React from 'react';
import queryString from 'query-string';
import Layout from './Layout';
import { useLocation } from 'react-router-dom';
import { PageRoute } from "../models/PageRoute";

const GenericErrorPage: React.FC<PageRoute> = (route: PageRoute) => {
  const location = useLocation();

  const props = queryString.parse(location.search);

  console.error("GENERIC ERROR: " + props.msg);

  return <Layout noindex={true}>Sorry!  An error occurred while processing your request.</Layout>;
};

export default GenericErrorPage;
